var map = {
	"./core/components/counselling-manager/counselling-manager.module": [
		"./src/app/core/components/counselling-manager/counselling-manager.module.ts",
		"core-components-counselling-manager-counselling-manager-module"
	],
	"./core/components/counsellor/counsellor.module": [
		"./src/app/core/components/counsellor/counsellor.module.ts",
		"core-components-counsellor-counsellor-module"
	],
	"./core/components/interview-trainer-manager/interview-trainer-manager.module": [
		"./src/app/core/components/interview-trainer-manager/interview-trainer-manager.module.ts",
		"core-components-interview-trainer-manager-interview-trainer-manager-module"
	],
	"./core/components/interview-trainer/interview-trainer.module": [
		"./src/app/core/components/interview-trainer/interview-trainer.module.ts",
		"core-components-interview-trainer-interview-trainer-module"
	],
	"./core/components/manager/manager.module": [
		"./src/app/core/components/manager/manager.module.ts",
		"core-components-manager-manager-module"
	],
	"./core/components/mentor/mentor.module": [
		"./src/app/core/components/mentor/mentor.module.ts",
		"core-components-mentor-mentor-module"
	],
	"./core/components/pages/pages.module": [
		"./src/app/core/components/pages/pages.module.ts",
		"core-components-pages-pages-module"
	],
	"./core/components/visa-counsellor-manager/visa-counsellor-manager.module": [
		"./src/app/core/components/visa-counsellor-manager/visa-counsellor-manager.module.ts",
		"core-components-visa-counsellor-manager-visa-counsellor-manager-module"
	],
	"./core/components/visa-counsellor/visa-counsellor.module": [
		"./src/app/core/components/visa-counsellor/visa-counsellor.module.ts",
		"core-components-visa-counsellor-visa-counsellor-module"
	],
	"./core/components/writer-manager/writer-manager.module": [
		"./src/app/core/components/writer-manager/writer-manager.module.ts",
		"core-components-writer-manager-writer-manager-module"
	],
	"./core/components/writer/writer.module": [
		"./src/app/core/components/writer/writer.module.ts",
		"core-components-writer-writer-module"
	],
	"src/app/core/components/counselling-manager/chat/chat.module": [
		"./src/app/core/components/counselling-manager/chat/chat.module.ts",
		"common",
		"src-app-core-components-counselling-manager-chat-chat-module"
	],
	"src/app/core/components/counselling-manager/colleges/colleges.module": [
		"./src/app/core/components/counselling-manager/colleges/colleges.module.ts",
		"common",
		"src-app-core-components-counselling-manager-colleges-colleges-module"
	],
	"src/app/core/components/counselling-manager/counsellors/counsellors.module": [
		"./src/app/core/components/counselling-manager/counsellors/counsellors.module.ts",
		"default~src-app-core-components-counselling-manager-counsellors-counsellors-module~src-app-core-comp~b4410491",
		"common",
		"src-app-core-components-counselling-manager-counsellors-counsellors-module"
	],
	"src/app/core/components/counselling-manager/dashboard/dashboard.module": [
		"./src/app/core/components/counselling-manager/dashboard/dashboard.module.ts",
		"src-app-core-components-counselling-manager-dashboard-dashboard-module"
	],
	"src/app/core/components/counselling-manager/edit-college/edit-college.module": [
		"./src/app/core/components/counselling-manager/edit-college/edit-college.module.ts",
		"src-app-core-components-counselling-manager-edit-college-edit-college-module"
	],
	"src/app/core/components/counselling-manager/edit-profile/edit-profile.module": [
		"./src/app/core/components/counselling-manager/edit-profile/edit-profile.module.ts",
		"src-app-core-components-counselling-manager-edit-profile-edit-profile-module"
	],
	"src/app/core/components/counselling-manager/notifications/notifications.module": [
		"./src/app/core/components/counselling-manager/notifications/notifications.module.ts",
		"default~src-app-core-components-counselling-manager-notifications-notifications-module~src-app-core-~05a261fc",
		"common",
		"src-app-core-components-counselling-manager-notifications-notifications-module"
	],
	"src/app/core/components/counselling-manager/students/students.module": [
		"./src/app/core/components/counselling-manager/students/students.module.ts",
		"default~src-app-core-components-counselling-manager-counsellors-counsellors-module~src-app-core-comp~b4410491",
		"common",
		"src-app-core-components-counselling-manager-students-students-module"
	],
	"src/app/core/components/counsellor/appointment/appointment.module": [
		"./src/app/core/components/counsellor/appointment/appointment.module.ts",
		"src-app-core-components-counsellor-appointment-appointment-module"
	],
	"src/app/core/components/counsellor/chat/chat.module": [
		"./src/app/core/components/counsellor/chat/chat.module.ts",
		"common",
		"src-app-core-components-counsellor-chat-chat-module"
	],
	"src/app/core/components/counsellor/colleges/colleges.module": [
		"./src/app/core/components/counsellor/colleges/colleges.module.ts",
		"common",
		"src-app-core-components-counsellor-colleges-colleges-module"
	],
	"src/app/core/components/counsellor/dashboard/dashboard.module": [
		"./src/app/core/components/counsellor/dashboard/dashboard.module.ts",
		"src-app-core-components-counsellor-dashboard-dashboard-module"
	],
	"src/app/core/components/counsellor/edit-profile/edit-profile.module": [
		"./src/app/core/components/counsellor/edit-profile/edit-profile.module.ts",
		"src-app-core-components-counsellor-edit-profile-edit-profile-module"
	],
	"src/app/core/components/counsellor/logs/logs.module": [
		"./src/app/core/components/counsellor/logs/logs.module.ts",
		"src-app-core-components-counsellor-logs-logs-module"
	],
	"src/app/core/components/counsellor/notifications/notifications.module": [
		"./src/app/core/components/counsellor/notifications/notifications.module.ts",
		"default~src-app-core-components-counselling-manager-notifications-notifications-module~src-app-core-~05a261fc",
		"common",
		"src-app-core-components-counsellor-notifications-notifications-module"
	],
	"src/app/core/components/counsellor/students/students.module": [
		"./src/app/core/components/counsellor/students/students.module.ts",
		"default~src-app-core-components-counselling-manager-counsellors-counsellors-module~src-app-core-comp~b4410491",
		"default~src-app-core-components-counsellor-students-students-module~src-app-core-components-mentor-s~98468935",
		"common",
		"src-app-core-components-counsellor-students-students-module"
	],
	"src/app/core/components/interview-trainer-manager/chat/chat.module": [
		"./src/app/core/components/interview-trainer-manager/chat/chat.module.ts",
		"common",
		"src-app-core-components-interview-trainer-manager-chat-chat-module"
	],
	"src/app/core/components/interview-trainer-manager/dashboard/dashboard.module": [
		"./src/app/core/components/interview-trainer-manager/dashboard/dashboard.module.ts",
		"src-app-core-components-interview-trainer-manager-dashboard-dashboard-module"
	],
	"src/app/core/components/interview-trainer-manager/edit-profile/edit-profile.module": [
		"./src/app/core/components/interview-trainer-manager/edit-profile/edit-profile.module.ts",
		"src-app-core-components-interview-trainer-manager-edit-profile-edit-profile-module"
	],
	"src/app/core/components/interview-trainer-manager/interview-trainers/interview-trainers.module": [
		"./src/app/core/components/interview-trainer-manager/interview-trainers/interview-trainers.module.ts",
		"src-app-core-components-interview-trainer-manager-interview-trainers-interview-trainers-module"
	],
	"src/app/core/components/interview-trainer-manager/notifications/notifications.module": [
		"./src/app/core/components/interview-trainer-manager/notifications/notifications.module.ts",
		"default~src-app-core-components-counselling-manager-notifications-notifications-module~src-app-core-~05a261fc",
		"common",
		"src-app-core-components-interview-trainer-manager-notifications-notifications-module"
	],
	"src/app/core/components/interview-trainer-manager/students/students.module": [
		"./src/app/core/components/interview-trainer-manager/students/students.module.ts",
		"src-app-core-components-interview-trainer-manager-students-students-module"
	],
	"src/app/core/components/interview-trainer/chat/chat.module": [
		"./src/app/core/components/interview-trainer/chat/chat.module.ts",
		"common",
		"src-app-core-components-interview-trainer-chat-chat-module"
	],
	"src/app/core/components/interview-trainer/dashboard/dashboard.module": [
		"./src/app/core/components/interview-trainer/dashboard/dashboard.module.ts",
		"src-app-core-components-interview-trainer-dashboard-dashboard-module"
	],
	"src/app/core/components/interview-trainer/edit-profile/edit-profile.module": [
		"./src/app/core/components/interview-trainer/edit-profile/edit-profile.module.ts",
		"src-app-core-components-interview-trainer-edit-profile-edit-profile-module"
	],
	"src/app/core/components/interview-trainer/notifications/notifications.module": [
		"./src/app/core/components/interview-trainer/notifications/notifications.module.ts",
		"default~src-app-core-components-counselling-manager-notifications-notifications-module~src-app-core-~05a261fc",
		"common",
		"src-app-core-components-interview-trainer-notifications-notifications-module"
	],
	"src/app/core/components/interview-trainer/sessions/sessions.module": [
		"./src/app/core/components/interview-trainer/sessions/sessions.module.ts",
		"src-app-core-components-interview-trainer-sessions-sessions-module"
	],
	"src/app/core/components/interview-trainer/students/students.module": [
		"./src/app/core/components/interview-trainer/students/students.module.ts",
		"src-app-core-components-interview-trainer-students-students-module"
	],
	"src/app/core/components/manager/chat/chat.module": [
		"./src/app/core/components/manager/chat/chat.module.ts",
		"common",
		"src-app-core-components-manager-chat-chat-module"
	],
	"src/app/core/components/manager/college-programs/college-programs.module": [
		"./src/app/core/components/manager/college-programs/college-programs.module.ts",
		"default~src-app-core-components-counselling-manager-counsellors-counsellors-module~src-app-core-comp~b4410491",
		"common",
		"src-app-core-components-manager-college-programs-college-programs-module"
	],
	"src/app/core/components/manager/colleges/colleges.module": [
		"./src/app/core/components/manager/colleges/colleges.module.ts",
		"common",
		"src-app-core-components-manager-colleges-colleges-module"
	],
	"src/app/core/components/manager/counselling-managers/counselling-managers.module": [
		"./src/app/core/components/manager/counselling-managers/counselling-managers.module.ts",
		"src-app-core-components-manager-counselling-managers-counselling-managers-module"
	],
	"src/app/core/components/manager/counsellors/counsellors.module": [
		"./src/app/core/components/manager/counsellors/counsellors.module.ts",
		"default~src-app-core-components-counselling-manager-counsellors-counsellors-module~src-app-core-comp~b4410491",
		"common",
		"src-app-core-components-manager-counsellors-counsellors-module"
	],
	"src/app/core/components/manager/dashboard/dashboard.module": [
		"./src/app/core/components/manager/dashboard/dashboard.module.ts",
		"src-app-core-components-manager-dashboard-dashboard-module"
	],
	"src/app/core/components/manager/edit-profile/edit-profile.module": [
		"./src/app/core/components/manager/edit-profile/edit-profile.module.ts",
		"src-app-core-components-manager-edit-profile-edit-profile-module"
	],
	"src/app/core/components/manager/interview-trainer-manager/interview-trainer-manager.module": [
		"./src/app/core/components/manager/interview-trainer-manager/interview-trainer-manager.module.ts",
		"src-app-core-components-manager-interview-trainer-manager-interview-trainer-manager-module"
	],
	"src/app/core/components/manager/interview-trainer/interview-trainer.module": [
		"./src/app/core/components/manager/interview-trainer/interview-trainer.module.ts",
		"src-app-core-components-manager-interview-trainer-interview-trainer-module"
	],
	"src/app/core/components/manager/locations/locations.module": [
		"./src/app/core/components/manager/locations/locations.module.ts",
		"common",
		"src-app-core-components-manager-locations-locations-module"
	],
	"src/app/core/components/manager/managers/managers.module": [
		"./src/app/core/components/manager/managers/managers.module.ts",
		"src-app-core-components-manager-managers-managers-module"
	],
	"src/app/core/components/manager/mentor/mentor.module": [
		"./src/app/core/components/manager/mentor/mentor.module.ts",
		"default~src-app-core-components-counselling-manager-counsellors-counsellors-module~src-app-core-comp~b4410491",
		"common",
		"src-app-core-components-manager-mentor-mentor-module"
	],
	"src/app/core/components/manager/notifications/notifications.module": [
		"./src/app/core/components/manager/notifications/notifications.module.ts",
		"default~src-app-core-components-counselling-manager-notifications-notifications-module~src-app-core-~05a261fc",
		"common",
		"src-app-core-components-manager-notifications-notifications-module"
	],
	"src/app/core/components/manager/program-categories/program-categories.module": [
		"./src/app/core/components/manager/program-categories/program-categories.module.ts",
		"common",
		"src-app-core-components-manager-program-categories-program-categories-module"
	],
	"src/app/core/components/manager/programs/programs.module": [
		"./src/app/core/components/manager/programs/programs.module.ts",
		"common",
		"src-app-core-components-manager-programs-programs-module"
	],
	"src/app/core/components/manager/students/students.module": [
		"./src/app/core/components/manager/students/students.module.ts",
		"default~src-app-core-components-counselling-manager-counsellors-counsellors-module~src-app-core-comp~b4410491",
		"common",
		"src-app-core-components-manager-students-students-module"
	],
	"src/app/core/components/manager/visa-counsellor-manager/visa-counsellor-manager.module": [
		"./src/app/core/components/manager/visa-counsellor-manager/visa-counsellor-manager.module.ts",
		"src-app-core-components-manager-visa-counsellor-manager-visa-counsellor-manager-module"
	],
	"src/app/core/components/manager/visa-counsellor/visa-counsellor.module": [
		"./src/app/core/components/manager/visa-counsellor/visa-counsellor.module.ts",
		"src-app-core-components-manager-visa-counsellor-visa-counsellor-module"
	],
	"src/app/core/components/manager/writer-managers/writer-managers.module": [
		"./src/app/core/components/manager/writer-managers/writer-managers.module.ts",
		"src-app-core-components-manager-writer-managers-writer-managers-module"
	],
	"src/app/core/components/manager/writers/writers.module": [
		"./src/app/core/components/manager/writers/writers.module.ts",
		"src-app-core-components-manager-writers-writers-module"
	],
	"src/app/core/components/mentor/appointment/appointment.module": [
		"./src/app/core/components/mentor/appointment/appointment.module.ts",
		"src-app-core-components-mentor-appointment-appointment-module"
	],
	"src/app/core/components/mentor/chat/chat.module": [
		"./src/app/core/components/mentor/chat/chat.module.ts",
		"common",
		"src-app-core-components-mentor-chat-chat-module"
	],
	"src/app/core/components/mentor/dashboard/dashboard.module": [
		"./src/app/core/components/mentor/dashboard/dashboard.module.ts",
		"src-app-core-components-mentor-dashboard-dashboard-module"
	],
	"src/app/core/components/mentor/edit-profile/edit-profile.module": [
		"./src/app/core/components/mentor/edit-profile/edit-profile.module.ts",
		"src-app-core-components-mentor-edit-profile-edit-profile-module"
	],
	"src/app/core/components/mentor/logs/logs.module": [
		"./src/app/core/components/mentor/logs/logs.module.ts",
		"src-app-core-components-mentor-logs-logs-module"
	],
	"src/app/core/components/mentor/notification/notification.module": [
		"./src/app/core/components/mentor/notification/notification.module.ts",
		"default~src-app-core-components-counselling-manager-notifications-notifications-module~src-app-core-~05a261fc",
		"common",
		"src-app-core-components-mentor-notification-notification-module"
	],
	"src/app/core/components/mentor/student/student.module": [
		"./src/app/core/components/mentor/student/student.module.ts",
		"default~src-app-core-components-counselling-manager-counsellors-counsellors-module~src-app-core-comp~b4410491",
		"default~src-app-core-components-counsellor-students-students-module~src-app-core-components-mentor-s~98468935",
		"common",
		"src-app-core-components-mentor-student-student-module"
	],
	"src/app/core/components/visa-counsellor-manager/chat/chat.module": [
		"./src/app/core/components/visa-counsellor-manager/chat/chat.module.ts",
		"common",
		"src-app-core-components-visa-counsellor-manager-chat-chat-module"
	],
	"src/app/core/components/visa-counsellor-manager/dashboard/dashboard.module": [
		"./src/app/core/components/visa-counsellor-manager/dashboard/dashboard.module.ts",
		"src-app-core-components-visa-counsellor-manager-dashboard-dashboard-module"
	],
	"src/app/core/components/visa-counsellor-manager/edit-profile/edit-profile.module": [
		"./src/app/core/components/visa-counsellor-manager/edit-profile/edit-profile.module.ts",
		"src-app-core-components-visa-counsellor-manager-edit-profile-edit-profile-module"
	],
	"src/app/core/components/visa-counsellor-manager/notifications/notifications.module": [
		"./src/app/core/components/visa-counsellor-manager/notifications/notifications.module.ts",
		"default~src-app-core-components-counselling-manager-notifications-notifications-module~src-app-core-~05a261fc",
		"common",
		"src-app-core-components-visa-counsellor-manager-notifications-notifications-module"
	],
	"src/app/core/components/visa-counsellor-manager/students/students.module": [
		"./src/app/core/components/visa-counsellor-manager/students/students.module.ts",
		"src-app-core-components-visa-counsellor-manager-students-students-module"
	],
	"src/app/core/components/visa-counsellor-manager/visa-counsellors/visa-counsellors.module": [
		"./src/app/core/components/visa-counsellor-manager/visa-counsellors/visa-counsellors.module.ts",
		"src-app-core-components-visa-counsellor-manager-visa-counsellors-visa-counsellors-module"
	],
	"src/app/core/components/visa-counsellor/chat/chat.module": [
		"./src/app/core/components/visa-counsellor/chat/chat.module.ts",
		"common",
		"src-app-core-components-visa-counsellor-chat-chat-module"
	],
	"src/app/core/components/visa-counsellor/dashboard/dashboard.module": [
		"./src/app/core/components/visa-counsellor/dashboard/dashboard.module.ts",
		"src-app-core-components-visa-counsellor-dashboard-dashboard-module"
	],
	"src/app/core/components/visa-counsellor/edit-profile/edit-profile.module": [
		"./src/app/core/components/visa-counsellor/edit-profile/edit-profile.module.ts",
		"src-app-core-components-visa-counsellor-edit-profile-edit-profile-module"
	],
	"src/app/core/components/visa-counsellor/notifications/notifications.module": [
		"./src/app/core/components/visa-counsellor/notifications/notifications.module.ts",
		"default~src-app-core-components-counselling-manager-notifications-notifications-module~src-app-core-~05a261fc",
		"common",
		"src-app-core-components-visa-counsellor-notifications-notifications-module"
	],
	"src/app/core/components/visa-counsellor/sessions/sessions.module": [
		"./src/app/core/components/visa-counsellor/sessions/sessions.module.ts",
		"src-app-core-components-visa-counsellor-sessions-sessions-module"
	],
	"src/app/core/components/visa-counsellor/students/students.module": [
		"./src/app/core/components/visa-counsellor/students/students.module.ts",
		"src-app-core-components-visa-counsellor-students-students-module"
	],
	"src/app/core/components/writer-manager/chat/chat.module": [
		"./src/app/core/components/writer-manager/chat/chat.module.ts",
		"common",
		"src-app-core-components-writer-manager-chat-chat-module"
	],
	"src/app/core/components/writer-manager/dashboard/dashboard.module": [
		"./src/app/core/components/writer-manager/dashboard/dashboard.module.ts",
		"src-app-core-components-writer-manager-dashboard-dashboard-module"
	],
	"src/app/core/components/writer-manager/edit-profile/edit-profile.module": [
		"./src/app/core/components/writer-manager/edit-profile/edit-profile.module.ts",
		"src-app-core-components-writer-manager-edit-profile-edit-profile-module"
	],
	"src/app/core/components/writer-manager/students/students.module": [
		"./src/app/core/components/writer-manager/students/students.module.ts",
		"src-app-core-components-writer-manager-students-students-module"
	],
	"src/app/core/components/writer-manager/writers/writers.module": [
		"./src/app/core/components/writer-manager/writers/writers.module.ts",
		"src-app-core-components-writer-manager-writers-writers-module"
	],
	"src/app/core/components/writer/chat/chat.module": [
		"./src/app/core/components/writer/chat/chat.module.ts",
		"common",
		"src-app-core-components-writer-chat-chat-module"
	],
	"src/app/core/components/writer/dashboard/dashboard.module": [
		"./src/app/core/components/writer/dashboard/dashboard.module.ts",
		"src-app-core-components-writer-dashboard-dashboard-module"
	],
	"src/app/core/components/writer/documents/documents.module": [
		"./src/app/core/components/writer/documents/documents.module.ts",
		"src-app-core-components-writer-documents-documents-module"
	],
	"src/app/core/components/writer/edit-profile/edit-profile.module": [
		"./src/app/core/components/writer/edit-profile/edit-profile.module.ts",
		"src-app-core-components-writer-edit-profile-edit-profile-module"
	],
	"src/app/core/components/writer/logs/logs.module": [
		"./src/app/core/components/writer/logs/logs.module.ts",
		"src-app-core-components-writer-logs-logs-module"
	],
	"src/app/core/components/writer/notifications/notifications.module": [
		"./src/app/core/components/writer/notifications/notifications.module.ts",
		"default~src-app-core-components-counselling-manager-notifications-notifications-module~src-app-core-~05a261fc",
		"common",
		"src-app-core-components-writer-notifications-notifications-module"
	],
	"src/app/core/components/writer/students/students.module": [
		"./src/app/core/components/writer/students/students.module.ts",
		"default~src-app-core-components-counselling-manager-counsellors-counsellors-module~src-app-core-comp~b4410491",
		"common",
		"src-app-core-components-writer-students-students-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;